import _definePage_default_0 from '/home/incubadoraifpr-sitevitrine/htdocs/sitevitrine.incubadoraifpr.com.br/resources/js/pages/[...error].vue?definePage&vue'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/incubadoraifpr-sitevitrine/htdocs/sitevitrine.incubadoraifpr.com.br/resources/js/pages/access-control.vue?definePage&vue'
import _definePage_default_3 from '/home/incubadoraifpr-sitevitrine/htdocs/sitevitrine.incubadoraifpr.com.br/resources/js/pages/login.vue?definePage&vue'
import _definePage_default_4 from '/home/incubadoraifpr-sitevitrine/htdocs/sitevitrine.incubadoraifpr.com.br/resources/js/pages/not-authorized.vue?definePage&vue'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/home/incubadoraifpr-sitevitrine/htdocs/sitevitrine.incubadoraifpr.com.br/resources/js/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  _mergeRouteRecord(
  {
    path: '/access-control',
    name: 'access-control',
    component: () => import('/home/incubadoraifpr-sitevitrine/htdocs/sitevitrine.incubadoraifpr.com.br/resources/js/pages/access-control.vue'),
    /* no children */
  },
  _definePage_default_2
  ),
  {
    path: '/home',
    name: 'home',
    component: () => import('/home/incubadoraifpr-sitevitrine/htdocs/sitevitrine.incubadoraifpr.com.br/resources/js/pages/home.vue'),
    /* no children */
  },
  {
    path: '/jardimdechuva',
    name: 'jardimdechuva',
    component: () => import('/home/incubadoraifpr-sitevitrine/htdocs/sitevitrine.incubadoraifpr.com.br/resources/js/pages/jardimdechuva.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/home/incubadoraifpr-sitevitrine/htdocs/sitevitrine.incubadoraifpr.com.br/resources/js/pages/login.vue'),
    /* no children */
  },
  _definePage_default_3
  ),
  {
    path: '/mac-address',
    name: 'mac-address',
    component: () => import('/home/incubadoraifpr-sitevitrine/htdocs/sitevitrine.incubadoraifpr.com.br/resources/js/pages/mac-address.vue'),
    /* no children */
  },
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/home/incubadoraifpr-sitevitrine/htdocs/sitevitrine.incubadoraifpr.com.br/resources/js/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_4
  ),
  {
    path: '/particulas-ar',
    name: 'particulas-ar',
    component: () => import('/home/incubadoraifpr-sitevitrine/htdocs/sitevitrine.incubadoraifpr.com.br/resources/js/pages/particulas-ar.vue'),
    /* no children */
  },
  {
    path: '/phmetro',
    name: 'phmetro',
    component: () => import('/home/incubadoraifpr-sitevitrine/htdocs/sitevitrine.incubadoraifpr.com.br/resources/js/pages/phmetro.vue'),
    /* no children */
  }
]
